export const ROLES = {
  TANK: "Tank",
  HEALER: "Healer",
  MELEE: "Melee DPS",
  RANGED: "Ranged DPS",
};

export const WOW_CLASSES = [
  {
    name: "Warrior",
    specs: [
      { name: "Arms", role: ROLES.MELEE },
      { name: "Fury", role: ROLES.MELEE },
      { name: "Protection", role: ROLES.TANK },
    ],
  },
  {
    name: "Paladin",
    specs: [
      { name: "Holy", role: ROLES.HEALER },
      { name: "Protection", role: ROLES.TANK },
      { name: "Retribution", role: ROLES.MELEE },
    ],
  },
  {
    name: "Hunter",
    specs: [
      { name: "Beast Mastery", role: ROLES.RANGED },
      { name: "Marksmanship", role: ROLES.RANGED },
      { name: "Survival", role: ROLES.MELEE },
    ],
  },
  {
    name: "Rogue",
    specs: [
      { name: "Assassination", role: ROLES.MELEE },
      { name: "Outlaw", role: ROLES.MELEE },
      { name: "Subtlety", role: ROLES.MELEE },
    ],
  },
  {
    name: "Priest",
    specs: [
      { name: "Discipline", role: ROLES.HEALER },
      { name: "Holy", role: ROLES.HEALER },
      { name: "Shadow", role: ROLES.RANGED },
    ],
  },
  {
    name: "Death Knight",
    specs: [
      { name: "Blood", role: ROLES.TANK },
      { name: "Frost", role: ROLES.MELEE },
      { name: "Unholy", role: ROLES.MELEE },
    ],
  },
  {
    name: "Shaman",
    specs: [
      { name: "Elemental", role: ROLES.RANGED },
      { name: "Enhancement", role: ROLES.MELEE },
      { name: "Restoration", role: ROLES.HEALER },
    ],
  },
  {
    name: "Mage",
    specs: [
      { name: "Arcane", role: ROLES.RANGED },
      { name: "Fire", role: ROLES.RANGED },
      { name: "Frost", role: ROLES.RANGED },
    ],
  },
  {
    name: "Warlock",
    specs: [
      { name: "Affliction", role: ROLES.RANGED },
      { name: "Demonology", role: ROLES.RANGED },
      { name: "Destruction", role: ROLES.RANGED },
    ],
  },
  {
    name: "Monk",
    specs: [
      { name: "Brewmaster", role: ROLES.TANK },
      { name: "Mistweaver", role: ROLES.HEALER },
      { name: "Windwalker", role: ROLES.MELEE },
    ],
  },
  {
    name: "Druid",
    specs: [
      { name: "Balance", role: ROLES.RANGED },
      { name: "Feral", role: ROLES.MELEE },
      { name: "Guardian", role: ROLES.TANK },
      { name: "Restoration", role: ROLES.HEALER },
    ],
  },
  {
    name: "Demon Hunter",
    specs: [
      { name: "Havoc", role: ROLES.MELEE },
      { name: "Vengeance", role: ROLES.TANK },
    ],
  },
  {
    name: "Evoker",
    specs: [
      { name: "Devastation", role: ROLES.RANGED },
      { name: "Preservation", role: ROLES.HEALER },
      { name: "Augmentation", role: ROLES.RANGED },
    ],
  },
];

// Official class colors: https://warcraft.wiki.gg/wiki/Class_colors
export const CLASS_COLORS = {
  "Death Knight": "#C41E3A",
  "Demon Hunter": "#A330C9",
  Druid: "#FF7C0A",
  Evoker: "#33937F",
  Hunter: "#AAD372",
  Mage: "#3FC7EB",
  Monk: "#00FF98",
  Paladin: "#F48CBA",
  Priest: "#FFFFFF",
  Rogue: "#FFF468",
  Shaman: "#0070DD",
  Warlock: "#8788EE",
  Warrior: "#C69B6D",
};

export const getSpecRole = (className, specName) => {
  const wowClass = WOW_CLASSES.find((c) => c.name === className);
  return wowClass?.specs.find((s) => s.name === specName)?.role || null;
};
